export default "__VITE_ASSET__f1556ff3__"